<ng-fields-config-common [field]="field"></ng-fields-config-common>
@switch (field.field_type) {
  @case ('branch_information') {
    <ng-field-branch-information [field]="field"></ng-field-branch-information>
  }
  @case ('branches') {
    <ng-field-branches [field]="field"></ng-field-branches>
  }
  @case ('calculated_fields') {
    <ng-field-calculated-fields [field]="field"></ng-field-calculated-fields>
  }
  @case ('calculated_field') {
    <ng-field-calculated-fields [field]="field"></ng-field-calculated-fields>
  }
  @case ('checkbox') {
    <ng-field-checkbox [field]="field"></ng-field-checkbox>
  }
  @case ('date') {
    <ng-field-date [field]="field"></ng-field-date>
  }
  @case ('dropdown') {
    <ng-field-dropdown [field]="field"></ng-field-dropdown>
  }
  @case ('duplicate_block') {
    <ng-field-duplicate-block [field]="field"></ng-field-duplicate-block>
  }
  @case ('employees') {
    <ng-field-employees [field]="field"></ng-field-employees>
  }
  @case ('file') {
    <ng-field-file [field]="field"></ng-field-file>
  }
  @case ('multiple_selection') {
    <ng-field-multiple-selection [field]="field"></ng-field-multiple-selection>
  }
  @case ('note') {
    <ng-field-note [field]="field"></ng-field-note>
  }
  @case ('radio') {
    <ng-field-radio [field]="field"></ng-field-radio>
  }
  @case ('richText') {
    <ng-field-rich-text [field]="field"></ng-field-rich-text>
  }
  @case ('scale') {
    <ng-field-scale [field]="field"></ng-field-scale>
  }
  @case ('selected_employee_information') {
    <ng-field-selected-employee-information [field]="field"></ng-field-selected-employee-information>
  }
  @case ('signature') {
    <ng-field-signature [field]="field"></ng-field-signature>
  }
  @case ('textfield') {
    <ng-field-text-field [field]="field"></ng-field-text-field>
  }
  @case ('user_information') {
    <ng-field-user-information [field]="field"></ng-field-user-information>
  }
}
